<template lang="pug">
header.l-article-header(:class="{hotoke:store.ui.state.hotoke}")
  .l-article-header__inner
    h1.l-article-header__name {{spot.name}}
    p.l-article-header__kana {{spot.kana}}
    .l-article-header__bunkazai(v-if="spot.bunkazai && spot.bunkazai.length > 0")
      p.l-article-header__bunkazai__item(v-for="bunkazai in spot.bunkazai") {{bunkazai}}
    h2.l-article-header__title {{spot.title}}
    .l-article-header__img(:style="styleObjectImg")
  
</template>
 
<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-article-header
  &__inner
    margin 0 auto
    +pc()
      padding 110px 0px 0
      width 480px
    +sp()
      padding 112px 0px 0
      width 600px

  &__name
    font-weight bold
    +pc()
      font-size 36px
    +sp()
      font-size 40px

  &__kana
    &:before
      content "【"
      margin-left -8px
    &:after
      content "】"
    +pc()
      font-size 18px
      margin-top -10px
    +sp()
      font-size 24px
      margin-top -10px
  
  &__bunkazai
    display flex
    justify-content flex-start
    +pc()
      margin-top 18px
    +sp()
      margin-top 20px
    &__item
      background-color #dd4517
      ^[0].hotoke &
        background-color #5f5f5f
      color #FFF
      font-weight bold
      border-radius 8px
      margin-left 15px
      &:first-child
        margin-left 0
      +pc()
        font-size 15px
        height 33px
        line-height 33px
        padding 0 20px
      +sp()
        font-size 20px
        height 40px
        line-height 40px
        padding 0 23px

  &__title
    font-weight bold
    +pc()
      font-size 22px
      margin-top 20px
    +sp()
      font-size 32px
      margin-top 20px

  &__img
    background-size cover
    border-radius 20px
    +pc()
      wh(480px,360px)
      margin-top 32px
    +sp()
      wh(600px,450px)
      margin-top 40px


</style>


<script>
import { defineComponent, computed, ref, onMounted, reactive } from "vue"
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
  name:'ArticleHeader',

  components:{},

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    const spot = computed(()=>{
      return store.api.getSpotById(route.params.id)
    })
    const styleObjectImg = computed(()=>{
      let obj = {}
      let url = store.api.getSpotById(route.params.id).thumbnail
      if(url){
        obj.backgroundImage = 'url('+ store.api.getSpotById(route.params.id).thumbnail +')'
      } else {
        obj.display = 'none'
      }
      
      return obj
    })

    return{
      spot,
      styleObjectImg,
      store
    }
  }
})
</script>
